import React from "react";
import { ReactComponent as PoolASvg } from "../img/tokenA.svg";
import { ReactComponent as PoolBSvg } from "../img/tokenB.svg";
import { stark } from "starknet";
import { waitForTxV2 } from "../utils";
import { CONTRACT_ADDRESS } from "../constants";
import { getStarknet } from "@argent/get-starknet";
const { getSelectorFromName } = stark;

function Liquidity({
  poolABalance,
  poolBBalance,
  pendingTransactions,
  changePendingTransactions,
}: {
  poolABalance: number;
  poolBBalance: number;
  pendingTransactions: Object;
  changePendingTransactions: Function;
}) {
  return (
    <div className="text-white flex flex-col justify-items-start items-start border border-white px-12 py-8 rounded-sm">
      <BalanceContent poolABalance={poolABalance} poolBBalance={poolBBalance} />
      <ResetBalanceButton
        pendingTransactions={pendingTransactions}
        changePendingTransactions={changePendingTransactions}
      />
    </div>
  );
}

function BalanceContent({
  poolABalance,
  poolBBalance,
}: {
  poolABalance: number;
  poolBBalance: number;
}) {
  if (poolABalance >= poolBBalance) {
    return (
      <div
        className="grid gap-x-6 gap-y-8 justify-items-start items-center mb-10"
        style={{ gridTemplateColumns: "50px 170px 100px" }}
      >
        <PoolABalance poolABalance={poolABalance} />
        <PoolBBalance poolBBalance={poolBBalance} />
      </div>
    );
  } else {
    return (
      <div
        className="grid gap-x-6 gap-y-8 justify-items-start items-center mb-10"
        style={{ gridTemplateColumns: "50px 170px 100px" }}
      >
        <PoolBBalance poolBBalance={poolBBalance} />
        <PoolABalance poolABalance={poolABalance} />
      </div>
    );
  }
}

function PoolABalance({ poolABalance }: { poolABalance: number }) {
  return (
    <>
      <PoolASvg className="w-11" />
      <div className="text-4xl font-semibold">
        {numberWithCommas(poolABalance)}
      </div>
      <div className="text-4xl font-medium">ATK</div>
    </>
  );
}

function PoolBBalance({ poolBBalance }: { poolBBalance: number }) {
  return (
    <>
      <PoolBSvg className="w-11" />
      <div className="text-4xl font-semibold">
        {numberWithCommas(poolBBalance)}
      </div>
      <div className="text-4xl font-medium">BTK</div>
    </>
  );
}

function ResetBalanceButton({
  pendingTransactions,
  changePendingTransactions,
}: {
  pendingTransactions: Object;
  changePendingTransactions: Function;
}) {
  return (
    <div
      className="bg-white text-black rounded-sm text-2xl font-semibold w-full flex justify-center p-3 mt-4 cursor-pointer"
      onClick={async () => {
        const starknet = getStarknet();
        let provider;
        // try {
        //   await starknet.enable();

        //   if (starknet.isConnected) {
        //     // If the extension was installed and successfully connected, you have access to a starknet.js Signer object to do all kind of requests through the users wallet contract.
        //     provider = starknet.signer;
        //   } else {
        //     // In case the extension wasn't successfully connected you still have access to a starknet.js Provider to read starknet states and sent anonymous transactions
        //     provider = starknet.provider;
        //   }
        // } catch (error) {
        //   provider = starknet.provider;
        // }

        provider = starknet.provider;

        const addTokenResponse = await provider.addTransaction({
          type: "INVOKE_FUNCTION",
          contract_address: CONTRACT_ADDRESS,
          entry_point_selector: getSelectorFromName("init_pool"),
          calldata: ["1000000", "1000000"],
        });

        const transactionHash = addTokenResponse.transaction_hash;
        const transactionResponse = await provider.getTransactionStatus(
          transactionHash
        );

        changePendingTransactions({
          ...pendingTransactions,
          [transactionHash]: transactionResponse.tx_status,
        });

        waitForTxV2(transactionHash, (transactionStatus: any) => {
          changePendingTransactions({
            ...pendingTransactions,
            [transactionHash]: transactionStatus,
          });
        });
      }}
    >
      "RESET"
    </div>
  );
}

function numberWithCommas(x: number) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export default Liquidity;
